export default "__VITE_ASSET__Bzry8xQn__"